import { jsx as _jsx } from "react/jsx-runtime";
import { FocusVisibleManager } from "use-focus-visible";
import { PopupMenuItem } from "../popupMenuItem/popupMenuItem";
import { StyledUL } from "./popupMenu.styles";
export function PopupMenu({ ariaLabel, popupMenuItems, show, activeItemIndex, openDirection, mainMenuIndex, setActiveItem, previewId, previewIdExtractor, }) {
    return (_jsx(StyledUL, Object.assign({ "data-preview-id": previewId, openDirection: openDirection, show: show, role: "menu", "aria-label": ariaLabel }, { children: popupMenuItems.map((item, index) => (_jsx(FocusVisibleManager, { children: _jsx(PopupMenuItem, { "data-preview-id": typeof previewIdExtractor === "function"
                    ? previewIdExtractor(item, index)
                    : undefined, onClick: () => {
                    if (!item.isDisabled) {
                        if (typeof item.onClick === "function") {
                            item.onClick({
                                menuItemIndex: mainMenuIndex,
                                popupMenuItemIndex: index,
                            });
                        }
                        setActiveItem({
                            menuItemIndex: mainMenuIndex,
                            popupMenuItemIndex: index,
                        });
                    }
                }, isDisabled: item.isDisabled, isActive: activeItemIndex === index, name: item.name, disabled: item.disabled, url: item.url }, item.name) }, JSON.stringify(item)))) })));
}
